export const ADD_MORE_COVERS_FLOW_ENHANCE_YOUR_COVERAGE =
  "ADD_MORE_COVERS_FLOW_ENHANCE_YOUR_COVERAGE";
export const ADD_MORE_COVERS_FLOW_REVIEW_AND_CONFIRM = "ADD_MORE_COVERS_FLOW_REVIEW_AND_CONFIRM";
export const ADD_MORE_COVERS_FLOW = "ADD_MORE_COVERS_FLOW";
